import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Editor from "@/components/Editor";
export default {
  components: {
    Editor: Editor
  },
  data: function data() {
    return {
      dialogShow: false,
      form: {
        extend: []
      }
    };
  },
  created: function created() {
    this.copyform = _objectSpread({}, this.form);
  },
  methods: {
    init: function init(datas) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var extendList, extend, key;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (datas) {
                  extendList = datas ? JSON.parse(datas) : [];
                  extend = [];

                  for (key in extendList) {
                    extend.push({
                      label: key,
                      value: extendList[key]
                    });
                  }

                  _this.form.extend = extend;

                  if (extend.length) {
                    _this.dialogShow = true;
                  } else {
                    _this.$message.success('没有参数');
                  }

                  _this.$nextTick(function () {
                    var dialogs_body = document.getElementsByClassName("dialogs_body");
                    dialogs_body.forEach(function (item) {
                      item.scrollTop = 0;
                    });
                  });
                } else {
                  _this.$message.success('没有参数');
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};